/**
 * 将教材分类扁平列表转为树并拍平为 a-select 选项（树序 + 缩进）。
 * @param {Array} list API 返回的分类数组
 * @param {{ showBookTypePrefix?: boolean }} opts showBookTypePrefix 为 true 时在 label 前加 [数字教材]/[电子书]
 * @returns {{ value: number, label: string }[]}
 */
export function isRootPid(pid) {
  return pid == null || pid === 0 || pid === ''
}

export function buildCategoryDisplayOptions(list, opts = {}) {
  const { showBookTypePrefix = true } = opts
  const byId = new Map()
  const roots = []
  ;(list || []).forEach((raw) => {
    if (!raw || raw.id == null) return
    byId.set(raw.id, { ...raw, children: [] })
  })
  ;(list || []).forEach((raw) => {
    if (!raw || raw.id == null) return
    const node = byId.get(raw.id)
    if (isRootPid(raw.pid)) {
      roots.push(node)
      return
    }
    const parent = byId.get(raw.pid)
    if (parent) parent.children.push(node)
    else roots.push(node)
  })
  const sortRec = (nodes) => {
    nodes.sort((a, b) => (a.sortKey ?? 0) - (b.sortKey ?? 0))
    nodes.forEach((n) => sortRec(n.children || []))
  }
  sortRec(roots)
  const result = []
  const walk = (nodes, depth) => {
    nodes.forEach((node) => {
      const typePrefix = showBookTypePrefix
        ? (node.bookType === 1 ? '[数字教材] ' : node.bookType === 2 ? '[电子书] ' : '')
        : ''
      result.push({
        value: node.id,
        label: `${typePrefix}${'　'.repeat(depth)}${depth ? '└ ' : ''}${node.name}`,
      })
      walk(node.children || [], depth + 1)
    })
  }
  walk(roots, 0)
  return result
}
